import Page from "../../framework/Page";
import ParentView from "../../framework/ParentView";
import CurrencyContainerView from "./CurrencyContainerView";

export default class RowContainerTitle extends ParentView {
    /**
     * @param {string} parentId
     * @param {string} elementId
     * @param {Totals} totals
     */
    constructor(parentId, totals) {
        super(parentId, parentId + '_one');

        this.addView(new CurrencyContainerView(this.elementId, totals));
    }

    /**
     * @override
     */
    initializeView() {
  
        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'top-row-one');

        // ////////////////////
        // // Game Title
        // ////////////////////

        // const gameTitleContainer = Page.createElement('div', container, null, 'game-title-container');
        // const gameTitleBody = Page.createElement('div', gameTitleContainer, null, 'game-title-body');
        // const gameTitleSpan = Page.createElement('div', gameTitleBody, null, 'game-title-display');

        // gameTitleSpan.innerHTML = 'Mining Crew';

        super.initializeView();        
    }
}